// @ts-nocheck legacy file transformed to TS
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, ServerError, TextField } from 'ic-snacks'
import instacart from 'legacy/common/instacart'
import withForm from 'legacy/common/withForm'
import deprecatedAnalytics from 'legacy/common/deprecatedAnalytics'
import { trackEvent } from 'utils/events/trackEvent'
import ApiResponseError from 'legacy/common/errors/ApiResponseError'
import { withNotificationContext } from 'legacy/common/context'
import { injectIntl } from 'react-intl'
import { withDepartmentsAndAislesI18nSupport } from 'legacy/routes/catalog/departments/departments.utils'

class FormView extends Component {
  /* eslint-disable react/forbid-prop-types */
  static propTypes = {
    aisle: PropTypes.object,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    formProps: PropTypes.object,
    errors: PropTypes.object,
    submitForm: PropTypes.func.isRequired,
    touched: PropTypes.object,
    handleChange: PropTypes.func,
    values: PropTypes.object,
    intl: PropTypes.object,
    getAisles: PropTypes.func,
    useI18n: PropTypes.bool,
  }
  /* eslint-enable react/forbid-prop-types */

  static defaultProps = {
    useI18n: false,
    aisle: {
      name: '',
    },
  }

  inputRef = React.createRef()
  inputRefFr = React.createRef()

  componentDidMount() {
    this.inputRef.current.FormComponent.input.focus()
    const aisleId = this.props.aisle && this.props.aisle.id

    if (aisleId) {
      trackEvent({
        id: 'catalog.departments.department.edit_aisle.viewed',
        description: 'Viewed the edit aisle section of the department page',
        data: { aisleId },
      })
    } else {
      trackEvent({
        id: 'catalog.departments.department.add_aisle.viewed',
        description: 'Viewed the add aisle section of the department page',
      })
    }
  }

  render() {
    const { formProps, errors, submitForm, touched, handleChange, values, intl } = this.props

    return (
      <Form formProps={{ 'data-cy': 'edit-aisle-form', ...formProps }} onSubmit={submitForm}>
        {errors.server && <ServerError style={{ width: '100%' }} text={errors.server} />}
        <TextField
          style={{ marginBottom: 5 }}
          ref={this.inputRef}
          fullWidth
          floatingLabelText={intl.formatMessage({ id: 'aisles.modal.label' })}
          name="name"
          required
          autoComplete="off"
          hasError={touched.name && !!errors.name}
          validationErrorText={touched.name && errors.name}
          value={values.name}
          onChange={handleChange}
        />

        {this.props.useI18n && (
          <TextField
            ref={this.inputRefFr}
            fullWidth
            floatingLabelText={intl.formatMessage({ id: 'aisles.modal.labelFr' })}
            name="name_fr"
            required
            autoComplete="off"
            hasError={touched.name_fr && !!errors.name_fr}
            validationErrorText={touched.name_fr && errors.name_fr}
            value={values.name_fr}
            onChange={handleChange}
          />
        )}
      </Form>
    )
  }
}

const handleSubmitError = notifyError => e => {
  if (e instanceof ApiResponseError && e.errors && e.errors.length) {
    if (e.status === 422) {
      // need to throw in this case so the form HOC handles the error and does not close the modal
      // otherwise will continue to onSuccess
      throw e
    }
    notifyError(e.errors[0])
  }
}

const NewDepartmentModal = withForm({
  title: ({ aisle, intl }) =>
    aisle && aisle.id
      ? intl.formatMessage({ id: 'aisles.modal.edit' })
      : intl.formatMessage({ id: 'catalog.aisle.new.title' }),
  width: 700,
  height: 360,
  mapPropsToValues: props => {
    const data = props.aisle || {
      name: '',
      name_fr: null,
    }

    return { ...data, warehouse_id: props.params.warehouse_id }
  },
  validate: (values, props) => {
    const errors = {}
    if (!values.name) {
      errors.name = 'Required'
    }

    if (props.useI18n && !values.name_fr) {
      errors.name_fr = 'Required'
    }

    return errors
  },
  onCreate: (data, { params, notifyError }) => {
    const { partner_id, warehouse_id, department_id } = params

    return instacart.go
      .post(
        `/v1/partners/${partner_id}/warehouses/${warehouse_id}/departments/${department_id}/aisles`,
        { data }
      )
      .then(response => {
        deprecatedAnalytics.track('catalog.aisle_create_success', {
          source_type: 'name',
          source_value: data.name,
          department_id: parseInt(department_id, 10),
          aisle_id: response.data.id,
        })

        return response
      })
      .catch(handleSubmitError(notifyError))
  },
  onUpdate: (data, { params, id, notifyError }) => {
    const { partner_id, warehouse_id, department_id } = params

    return instacart.go
      .put(
        `/v1/partners/${partner_id}/warehouses/${warehouse_id}/departments/${department_id}/aisles/${id}`,
        { data }
      )
      .then(response => {
        deprecatedAnalytics.track('catalog.aisle_update_success', {
          source_type: 'name',
          source_value: data.name,
          department_id: parseInt(department_id, 10),
          aisle_id: parseInt(id, 10),
        })

        return response
      })
      .catch(handleSubmitError(notifyError))
  },
  onError: (errors, { intl }, setErrors) => {
    setErrors({
      server:
        errors === 'trademark-error'
          ? intl.formatMessage({ id: 'catalog.error.trademark' })
          : errors,
    })
  },
  onSuccess: ({ onClose, getAisles }) => {
    getAisles()
    onClose()
  },
  onClose: ({ onClose }) => onClose(),
})(FormView)

export default injectIntl(
  withNotificationContext(withDepartmentsAndAislesI18nSupport(NewDepartmentModal))
)
